<template>
  <div class="container">
    <div class="grid-wrapper">
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/A.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/B.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/U.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/C.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/D.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/E.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/F.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/G.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/H.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/I.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/J.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/Q.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/R.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/K.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/L.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/M.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/N.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/T.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/S.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img src="../assets/3.webp" alt="gallery image" />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img src="../assets/4.webp" alt="gallery image" />
        </div>
      </div>
      <div class="grid-item w-span">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/O.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item w-span">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/P.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item w-span">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/REAPER.webp"
            alt="gallery image"
          />
        </div>
      </div>

      <div class="grid-item w-span">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/MANCHESTER.webp"
            alt="gallery image"
          />
        </div>
      </div>
      <div class="grid-item w-span">
        <div class="card">
          <img
            src="../assets/Gallery/CompressedImages/RIAAN.webp"
            alt="gallery image"
          />
        </div>
      </div>
    </div>
  </div>
</template>



<style scoped>
.container {
  margin: 2rem auto;
  max-width: 1000px;
  position: relative;
}
.grid-wrapper {
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin: 2rem auto;
  padding: 0 1rem;
}
.grid-item {
  width: 100%;
  height: 100%;
  box-shadow: 7px 10px 12px 2px rgba(0, 0, 0, 0.65);
  border-radius: 5px;
  overflow: hidden;
}
.grid-item .card {
  width: 100%;
  height: 100%;
}
.grid-item .card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.w-span {
  grid-column: span 2;
}
/* =======================MEDIA============================== */
@media screen and (min-width: 500px) {
  .grid-wrapper {
    padding: 3rem;
    /* gap: 10px; */
    grid-template-columns: repeat(3, 1fr);
  }

  .grid-item {
    background-color: #ccc4c4;
    /* padding: 0.15rem; */
    grid-column: span 1;
  }
  .w-span {
    grid-column: span 3;
  }
}
@media screen and (min-width: 768px) {
}
</style>